import { render, staticRenderFns } from "./MapComgyObjectWizardControl.global.vue?vue&type=template&id=20ccb55c&lang=pug&"
import script from "./MapComgyObjectWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./MapComgyObjectWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports